import { META_CATEGORIES } from './metaPricingCalculator';
export const USAGE_TIMEZONE = 'America/Sao_Paulo';
const integerFormatter = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 0,
});
export const usageCount = value => integerFormatter.format(Number(value) || 0);
export const maskUsageCount = value => {
  const digits = String(value ?? '').replace(/\D/g, '');
  return digits ? usageCount(digits) : '';
};
export const formatUsageRate = value => {
  if (value === '' || value === null || value === undefined) return '';
  return `R$ ${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(Number(value))}`;
};
// A digitação aceita ponto ou vírgula. Pontos de milhar só são removidos
// quando a entrada já está no formato brasileiro de moeda.
const normalizeUsageRate = value => {
  const raw = String(value ?? '');
  const clean = raw.replace(/R\$|\s/g, '');
  if (clean.includes(',')) return clean.replace(/\./g, '').replace(',', '.');
  if (raw.includes('R$')) {
    const groupedDecimal = clean.match(/^([1-9]\d{0,2}(?:\.\d{3})+)\.(\d*)$/);
    if (groupedDecimal)
      return `${groupedDecimal[1].replace(/\./g, '')}.${groupedDecimal[2]}`;
    if (/^[1-9]\d{0,2}(?:\.\d{3})+$/.test(clean))
      return clean.replace(/\./g, '');
  }
  return clean;
};
export const maskUsageRate = value => {
  const clean = normalizeUsageRate(value).replace(/[^0-9.]/g, '');
  if (!clean) return '';
  const [whole, ...fraction] = clean.split('.');
  return `R$ ${usageCount(whole)}${fraction.length ? `,${fraction.join('').slice(0, 6)}` : ''}`;
};
export const parseUsageRate = value => normalizeUsageRate(value);

export function usageMonthOptions(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: USAGE_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
  }).formatToParts(now);
  const year = Number(parts.find(part => part.type === 'year').value);
  const currentMonth =
    Number(parts.find(part => part.type === 'month').value) - 1;
  return Array.from({ length: 15 }, (_, index) => {
    const date = new Date(year, currentMonth + 2 - index, 1);
    return {
      value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
      label: date.toLocaleDateString('pt-BR', {
        month: 'long',
        year: 'numeric',
      }),
      current: index === 2,
    };
  });
}

export function usageCsv(report) {
  const rows = [
    [
      'Mês',
      'WABA',
      'Caixa',
      'Número',
      'Fuso',
      'Entregues',
      'Com cobrança Meta',
      'Sem classificação',
      'Serviço',
      'Meta configurada',
      '% atingido',
      'Acima da meta',
      'Estimativa parcial BRL',
      'Sem tarifa aplicável',
      ...Object.values(META_CATEGORIES).flatMap(label => [
        `${label} · com cobrança`,
        `${label} · gratuitas`,
        `${label} · sem classificação`,
        `${label} · tarifa BRL`,
        `${label} · estimativa BRL`,
        `${label} · sem tarifa`,
      ]),
    ],
    ...report.numbers.map(row => [
      report.month,
      row.waba_id,
      row.name,
      row.phone_number,
      USAGE_TIMEZONE,
      row.delivered,
      row.billable,
      row.unknown_pricing,
      row.service,
      row.allowance,
      row.allowance_percent,
      row.excess,
      row.estimated_cost_brl,
      row.unpriced,
      ...Object.keys(META_CATEGORIES).flatMap(category => {
        const charge = row.charges?.[category];
        return charge
          ? [
              charge.billable,
              charge.free,
              charge.unknown_pricing,
              charge.rate_brl,
              charge.estimated_cost_brl,
              charge.unpriced,
            ]
          : ['', '', '', '', '', ''];
      }),
    ]),
  ];
  return rows
    .map(row =>
      row
        .map(value => {
          const text = String(value ?? '');
          const safe = /^[\s]*[=+@-]/.test(text) ? `'${text}` : text;
          return `"${safe.replaceAll('"', '""')}"`;
        })
        .join(';')
    )
    .join('\r\n');
}
